import React, { FC, PropsWithChildren } from 'react';
import { StyledLayout, StyledContent } from '../styled';
import { AppHeader } from './header';

export const AppContent: FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledLayout>
      <AppHeader />
      <StyledContent>{children}</StyledContent>
    </StyledLayout>
  );
};
